(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-to-top"]) return;
  try {
    

backToTop = document.getElementById("backToTop");

scrollFunction() 

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    backToTop.style.display = "block";
  } else {
    backToTop.style.display = "none";
  }
}

backToTop.addEventListener('click', function() {
  topFunction() 
})

function topFunction() {
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0;
}



  } catch(e) { console.error(e); }
})();
})();
